/**
 * Ashore API
 * All Endpoints to control your ashore account
 *
 * The version of the OpenAPI document: V1
 * Contact: info@ashoreapp.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The PdfExtractedJpgPage model module.
 * @module model/PdfExtractedJpgPage
 * @version V1
 */
class PdfExtractedJpgPage {
    /**
     * Constructs a new <code>PdfExtractedJpgPage</code>.
     * @alias module:model/PdfExtractedJpgPage
     */
    constructor() { 
        
        PdfExtractedJpgPage.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>PdfExtractedJpgPage</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/PdfExtractedJpgPage} obj Optional instance to populate.
     * @return {module:model/PdfExtractedJpgPage} The populated <code>PdfExtractedJpgPage</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new PdfExtractedJpgPage();

            if (data.hasOwnProperty('key')) {
                obj['key'] = ApiClient.convertToType(data['key'], 'String');
            }
            if (data.hasOwnProperty('uri')) {
                obj['uri'] = ApiClient.convertToType(data['uri'], 'String');
            }
            if (data.hasOwnProperty('page')) {
                obj['page'] = ApiClient.convertToType(data['page'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>PdfExtractedJpgPage</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>PdfExtractedJpgPage</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['key'] && !(typeof data['key'] === 'string' || data['key'] instanceof String)) {
            throw new Error("Expected the field `key` to be a primitive type in the JSON string but got " + data['key']);
        }
        // ensure the json data is a string
        if (data['uri'] && !(typeof data['uri'] === 'string' || data['uri'] instanceof String)) {
            throw new Error("Expected the field `uri` to be a primitive type in the JSON string but got " + data['uri']);
        }

        return true;
    }


}



/**
 * @member {String} key
 */
PdfExtractedJpgPage.prototype['key'] = undefined;

/**
 * @member {String} uri
 */
PdfExtractedJpgPage.prototype['uri'] = undefined;

/**
 * @member {Number} page
 */
PdfExtractedJpgPage.prototype['page'] = undefined;






export default PdfExtractedJpgPage;

